module.exports = __webpack_public_path__ + "static/media/2021_4G8A8744.96611037.jpg";